<template>
    <div :class="['hlDrillProc',getPlatformClass]">
        
        <div :class="['techDrillScroller']">
          <div :class="['drillProcCont2', isDrillFadeout === true ? 'drillFadeout' : '']">          
              <img class="itemImg" :src="infoImg" />            
          </div>
        </div>
        
        <div :class="['drillplatformBarContainer',plaformIndex>-1 ? 'mounted':'']">
          <platformbar 
            skinMode = "light"
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "4"            
            @platform-change="onPlatformChange">
          </platformbar>
        </div>

        <!--
        <div :class="['lowerText',plaformIndex>-1 ? 'mounted':'']">
            <div v-for="(item,index) in sectionData.contents" :key="index">
              * {{localize(item)}}
            </div>
        </div>
        -->

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default {
    components:{platformbar,splitter},
    props: {
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            infoImg:'',
            plaformIndex:-1,
            isDrillFadeout:true
        }
    },
    methods:
    {
      onPlatformChange(plaformIndex)
      {
        var vm = this;        

        vm.isDrillFadeout = true;
        
        setTimeout(() => {
          vm.plaformIndex = plaformIndex;
          vm.infoImg = vm.sectionData.platforms[plaformIndex].img;  
        }, 500);

        setTimeout(() => {
          vm.isDrillFadeout = false;
        }, 1100);
        
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["xSelectedPlatform","minisite_data","siteDataReady"]),
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};
</script>

<style>
    .hlDrillProc
    {      
        background: transparent;
        position:relative;
        width: 100%;
        height: 100%;        
        z-index: 100;
        /* display: grid; */
        /* align-items: center; */
    }
    .hlDrillProc .container
    {
      width: 100%;
    }
    .hlDrillProc .title
    {
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
        color: var(--text-blue);
        text-align:left;        
        position:absolute;
        top:0px;left: 0px;
        padding-left: max(180px, 10vw);
        top:100px;
        
    }
    .hlDrillProc .lowerText
    {
        position: absolute;
        bottom: 50px;
        left: 12vw;
        width: 76vw;
        font-size: 16px;
        opacity: 0;
    }
    .hlDrillProc .lowerText.mounted
    {
      opacity: 1;
    }

    .hlDrillProc .techDrillScroller
    {
    }

    .hlDrillProc .drillplatformBarContainer
    {
      padding-top: 50px;
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      /* position: absolute;bottom: 30px; */
      width: 100%;
    }
    .hlDrillProc .drillplatformBarContainer.mounted
    {
      /*top:calc(100vh - 150px);*/
    }      
    .drillProcCont2
    {
      /* position: absolute;top:47%;transform: translateY(-50%); */
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.5s;
      background: transparent;
    }
    .drillProcCont2.drillFadeout
    {
      opacity: 0;
    }

    .drillProcCont2 .itemImg
    {
      width: 45vw;height:auto;
    }
    .drillProcCont2 .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #fff;font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .hlDrillProc
    {
        min-height: 100vh;
        width: 100vw !important;
        height: auto;
        display: block;
        padding-bottom: 100px;        
    }
    .techDrillScroller
    {
      display: block;
      max-width: 100vw;
      height: calc(100vw + 30px);
      overflow-x: auto;
      overflow-y: hidden;
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
      transition-delay: 0.7s;
      transition: opacity ease-in 0.3s;
      opacity: 1;      
      padding-top: 0px;
      padding-bottom: 0px;
    }    
    .drillScroller::-webkit-scrollbar {
        display: none;
    }
    .drillScroller.scrollerFadeout
    {
      opacity: 0 !important;
    }
    .hlDrillProc .drillplatformBarContainer
    {
      position:static;
      transform: none;
      width: 100%;
      padding-top: 0px;
    }    





    .drillProcCont2
    {
      position: initial;
      pointer-events: none;
      transition: all ease 0.8s;
      width: calc(160vw + 100px);
      float: left;
      display: block;
      padding-left: 50px;
      height: 100vw;
      transform: translateY(0px);

    }    




    .drillScroller .itemImg
    {      
      width: 160vw;
      height: auto;
      float: left;
    }
    .hlDrillProc .lowerText
    {
        clear: both;
        font-size: 15px;
        margin: auto;        
        position: static;
        padding: 30px 0px 0px 0px;        
    }    



  }  
</style>